import clsx from 'clsx';
import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';
import { Icon } from '../icons/Icon.js';
import type { IconName } from '../icons/registry.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div {...rest} className={clsx('tb-card', className)}>
      {children}
    </div>
  );
}

export interface SelectableCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: IconName;
  title: string;
  description?: string;
  selected?: boolean;
  trailing?: ReactNode;
}

export function SelectableCard({
  icon,
  title,
  description,
  selected = false,
  trailing,
  className,
  ...rest
}: SelectableCardProps) {
  return (
    <button
      {...rest}
      type={rest.type ?? 'button'}
      aria-pressed={selected}
      className={clsx(
        'tb-card',
        'tb-card--interactive',
        selected && 'tb-card--selected',
        className,
      )}
    >
      <div className="tb-row">
        {icon ? <Icon name={icon} size={22} /> : null}
        <div className="tb-grow tb-stack" style={{ gap: 2 }}>
          <span style={{ fontWeight: 600 }}>{title}</span>
          {description ? <span className="tb-hint">{description}</span> : null}
        </div>
        {trailing ?? (selected ? <Icon name="check" size={18} /> : null)}
      </div>
    </button>
  );
}
